export function toFarsiNumber(value) {
  if (value === undefined || value === null) {
    return "";
  }
  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return value.toString().replace(/\d/g, (x) => farsiDigits[x]);
}
